import {Flex, Text, Button, Center, Box} from '@chakra-ui/react';
import {useEffect, useState} from 'react';
import router from 'next/router';
import {useGetListingsByAssetIdQuery} from '../../graphql/generated';
import {useGeolocation} from '../../hooks/geolocation';

export interface MarketplaceFooterBarProps {
  assetId: string;
  collectors: number;
  link: string;
  color: string;
  darkMode?: boolean;
}

export const MarketplaceFooterBar: React.FC<MarketplaceFooterBarProps> = ({
  assetId,
  collectors,
  link,
  color,
  darkMode = false,
}) => {
  const {currency, currencyPostfix} = useGeolocation();
  const marketplaceListings = useGetListingsByAssetIdQuery({
    variables: {assetId: assetId || ''},
  });
  const [startingFromAmount, setStartingFromAmount] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const listings = marketplaceListings.data?.getListingsByAssetId;
    if (
      !marketplaceListings.loading &&
      listings &&
      listings?.length > 0 &&
      Array.isArray(listings)
    ) {
      let cheapestListingPrice = 0;

      listings.forEach((item) => {
        if (item && item.status === 'ACTIVE') {
          if (
            cheapestListingPrice === 0 ||
            item.price.value < cheapestListingPrice
          )
            cheapestListingPrice = item.price.value;
        }
      });

      if (cheapestListingPrice && cheapestListingPrice > 0) {
        setStartingFromAmount(cheapestListingPrice);
        setIsActive(cheapestListingPrice > 0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marketplaceListings.loading]);

  return (
    <Box position="relative">
      <Center
        background={darkMode ? 'black' : 'white'}
        boxShadow="0px -4px 8px rgba(0, 0, 0, 0.1)"
        position="fixed"
        bottom="0"
        width="100%"
        zIndex="banner"
        py={2}
        borderTopRadius={{base: '14px', md: '0'}}
      >
        <Flex
          width="600px"
          justifyContent="space-between"
          alignItems="center"
          px={{base: 2, md: '0'}}
        >
          <Text
            textStyle="button"
            fontSize="12px"
            lineHeight="16.8px"
            display={{base: 'none', md: 'block'}}
            color={darkMode ? 'white' : 'auto'}
          >
            {collectors} existing collector{collectors !== 1 ? 's' : ''}
          </Text>
          <Flex alignItems="center" display={{base: 'none', md: 'flex'}}>
            {isActive && (
              <>
                <Text
                  textStyle="button"
                  lineHeight="22.4px"
                  color={darkMode ? 'white' : 'auto'}
                >
                  Starting from
                </Text>
                <Text textStyle="h5" color={color} ml={3}>
                  {currency}
                  {startingFromAmount.toString()}
                  {currencyPostfix}
                </Text>
              </>
            )}
            {!isActive && (
              <>
                <Text textStyle="h7" color={color} ml={3}>
                  There are no active listings
                </Text>
              </>
            )}
          </Flex>
          <Button
            colorScheme="aqua"
            onClick={() => router.push(link)}
            p="9px 26px"
            width={{base: '100%', md: 'auto'}}
          >
            <Text as="span" textStyle="h7">
              Buy Pieces
            </Text>
          </Button>
        </Flex>
      </Center>
    </Box>
  );
};
